import React,{useState,useEffect,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {Toaster} from 'react-hot-toast';
/* -- biz9 import start -- */
import {Str,Log} from "biz9-utility";
import FormNoData from '../../../formNoData';
import {Data_Logic} from "biz9-data-app";
import {Field,Message,Title,Type,Url} from "../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,Template,Toast_Message,Storage,System,User} from "../../../../project";
import {Image_Format} from "biz9-image";
import {Favorite_Logic,Favorite_Table,Favorite_Service,Favorite_Url} from "biz9-favorite";
import {Portal_Table,Portal_Field,Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_Favorite} from "biz9-portal-app";
/* -- biz9 import end -- */
const Dashboard_User_Favorite = () => {
    const [user,setUser] = useState(User.get());
    const [val_sub_page_title,setValSubPageTitle] = useState("Favorites");
    const [favorites,setFavorites] = useState([]);
    useEffect(() => {
        get_data();
    },[]);
    async function get_data() {
        // -- get-user-favorites --
        Toast_Message.loading(Message.LOADING);
        const [response,data] = await Portal_Remote_Favorite.user_search(App.get_url(Portal_Url.FAVORITE_USER_SEARCH),Portal_Table.PRODUCT,User.get().id);
        setFavorites(data.items);
        Storage.post_favorites(data.items);
        Toast_Message.dismiss();
   }
    async function btn_delete(id: any) {
        if (window.confirm('Are you sure?')) {
            Toast_Message.loading(Message.DELETING);
            let favorite = Favorite_Logic.get({id:id,table:Portal_Table.PRODUCT},User.get());
            let [response,data] = await Portal_Remote_Favorite.delete(App.get_url(Portal_Url.FAVORITE_DELETE),favorite);
            Toast_Message.success(response.message);
            setFavorites(favorites.filter(item=>item[Portal_Field.PARENT_ID]!==id));
            Storage.post_favorites(favorites.filter(item=>item[Portal_Field.PARENT_ID]!==id));
        }
    };
    const imgSlider = {
dots: true,
      infinite: true,
      speed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false, // set to true if you want to use custom arrows
      responsive: [
      {
breakpoint: 1000,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 768,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 550,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
    };
    return (
            <>
        <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content">
            <div className="row">
            {/* Manage Gigs */}
            <div className="col-12">
            <div className="d-flex mb-4 align-items-center justify-content-between gap-3 flex-wrap">
            <div className="main-title">
            <h4 className="mb-0">{val_sub_page_title}</h4>
            </div>
            </div>
            <div className="row">
            {favorites.length<=0 && <div><FormNoData/></div>}
            {favorites.map((item) => (
                        <div className="col-xl-4 col-md-6">
                        <div className="gigs-grid">
                        <div className="gigs-img">
                        <div className="img-slider owl-carousel">
                        <div className="slide-images">
                        <Link to={"/app/"+item.parent.title_url}>
                        <ImageWithBasePath
                        src={Image.get_url(item.parent.image_filename,Image_Format.ORIGINAL)}
                        className="img-fluid"
                        alt="img"
                        />
                        </Link>
                        </div>
                        </div>
                        <div className="fav-selection">
                        <Link onClick={() => btn_delete(item.parent_id)} to="#">
                        <i className="ti ti-heart-filled" />
                        </Link>
                        </div>
                        </div>
                        <div className="gigs-content">
                        <div className="gigs-info">
                        <Link
                        to={"/app/"+item.parent.title_url}
                        className="badge bg-primary-light"
                        >
                        {item.parent.category}
            </Link>
                </div>
                <div className="gigs-title">
                <h3>
                <Link to={"/app/"+item.parent.title_url}>
                {item.parent.title}
            </Link>
                </h3>
                </div>
                <div className="gigs-card-footer">
                <h5>{Str.get_money(item.parent.cost)}</h5>
                <span className="badge">{item.parent.delivery_time}</span>
                </div>
                </div>
                </div>
                </div>
                ))}
    </div>
        </div>
        {/* /Manage Gigs */}
    </div>
    {/*
        <div className="text-center">
        <Link
        to="#"
        className="btn btn-lg btn-dark d-inline-flex align-items-center"
        >
        <i className="ti ti-loader-3 me-2" />
        Load More
        </Link>
        </div>
        */}
    </div>
        </div>
        {/* /Page Content */}
    </>
        )
}
export default Dashboard_User_Favorite
